import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import AdminAPI from "../../services/adminApi";
import { toast } from "react-toastify";

function Farmers() {
  const [farmers, setFarmers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchFarmers();
  }, []);

  const fetchFarmers = async () => {
    try {
      setLoading(true);

      const res = await AdminAPI.get(
        `/farmers?search=${search}`
      );

      setFarmers(res.data);

    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch farmers");
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await AdminAPI.put(
        `/farmers/status/${id}`,
        { status }
      );

      toast.success("Farmer status updated");
      fetchFarmers();

    } catch (err) {
      console.log(err);
      toast.error("Status update failed");
    }
  };

  const deleteFarmer = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this farmer?"
    );

    if (!confirmDelete) return;

    try {
      await AdminAPI.delete(`/farmers/${id}`);

      toast.success("Farmer deleted successfully");
      fetchFarmers();

    } catch (err) {
      console.log(err);
      toast.error("Delete failed");
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        <div className="card shadow border-0 mt-4">
          <div className="card-body">

            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
              <h4 className="mb-0">
                👨‍🌾 Farmer Management
              </h4>

              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name / email / mobile"
                  style={{ width: "320px" }}
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                />

                <button
                  className="btn btn-success"
                  onClick={fetchFarmers}
                >
                  Search
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-success">
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Village</th>
                    <th>Primary Crop</th>
                    <th>Status</th>
                    <th width="350">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        Loading farmers...
                      </td>
                    </tr>
                  ) : farmers.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No farmers found
                      </td>
                    </tr>
                  ) : (
                    farmers.map((farmer) => (
                      <tr key={farmer.id}>
                        <td>{farmer.full_name}</td>
                        <td>{farmer.email}</td>
                        <td>{farmer.mobile}</td>
                        <td>{farmer.village}</td>
                        <td>{farmer.primary_crop}</td>

                        <td>
                          <span
                            className={`badge ${
                              farmer.status === "active"
                                ? "bg-success"
                                : farmer.status === "suspended"
                                ? "bg-danger"
                                : "bg-secondary"
                            }`}
                          >
                            {farmer.status}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex gap-2 flex-wrap">

                            <Link
                              to={`/admin/farmer/${farmer.id}`}
                              className="btn btn-primary btn-sm"
                            >
                              View Details
                            </Link>

                            <button
                              className="btn btn-success btn-sm"
                              onClick={() =>
                                updateStatus(
                                  farmer.id,
                                  "active"
                                )
                              }
                            >
                              Activate
                            </button>

                            <button
                              className="btn btn-warning btn-sm"
                              onClick={() =>
                                updateStatus(
                                  farmer.id,
                                  "suspended"
                                )
                              }
                            >
                              Suspend
                            </button>

                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                deleteFarmer(farmer.id)
                              }
                            >
                              Delete
                            </button>

                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>

              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Farmers;